module.exports = __webpack_public_path__ + "img/U1F385.fb2da9bc.png";